/* eslint-disable @typescript-eslint/no-magic-numbers */
import useComponentTracking from 'hooks/useComponentTracking';
import { useCallback, useEffect, useState } from 'react';

const useVisibilityTester = (isTracking: boolean, limit: number) => {
  const {
    startTracking,
    stopTracking,
    resetTracking,
    getVisibleDuration,
    getTrackingDuration,
    getTrackingStartTime,
    getLastVisibleTime,
    getAccumulatedVisibleTime,
  } = useComponentTracking();

  const [metrics, setMetrics] = useState(
    [] as {
      visibleDuration: number;
      trackingDuration: number;
      trackingStartTime: string;
      lastVisibleTime: string;
      accumulatedVisibleTime: number;
    }[],
  );

  const updateMetric = (newValues: {
    visibleDuration: number;
    trackingDuration: number;
    trackingStartTime: string;
    lastVisibleTime: string;
    accumulatedVisibleTime: number;
  }) => {
    setMetrics((previousMetrics) => {
      const updatedArray = [newValues, ...previousMetrics];
      return updatedArray.length > limit ? updatedArray.slice(-1 * limit) : updatedArray;
    });
  };

  useEffect(() => {
    if (!isTracking) return () => {};
    const interval = setInterval(() => {
      updateMetric({
        visibleDuration: getVisibleDuration() / 1000,
        trackingDuration: getTrackingDuration() / 1000,
        trackingStartTime: new Date(getTrackingStartTime() || 0).toISOString(),
        lastVisibleTime: new Date(getLastVisibleTime() || 0).toISOString(),
        accumulatedVisibleTime: getAccumulatedVisibleTime() / 1000,
      });
    }, 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getVisibleDuration,
    getTrackingDuration,
    getTrackingStartTime,
    getLastVisibleTime,
    getAccumulatedVisibleTime,
    isTracking,
  ]);

  const resetTrackingHelper = useCallback(() => {
    setMetrics([]);
    resetTracking();
  }, [resetTracking]);

  return {
    startTracking,
    stopTracking,
    resetTracking: resetTrackingHelper,
    metrics,
  };
};

export default useVisibilityTester;
